import { Html, html } from 'rune-ts';
import {
  MarppleShopBrandDealLogo,
  MarppleShopEbookLogo,
  MarppleShopGoodsLogo,
  MarppleShopHandmadeLogo,
} from '@services/MarppleShop/shared/components/atoms/Icon/identity_icons.ts';
import { createBuilderByCateRootCode } from '@services/MarppleShop/features/ProductList/util';
import { MarppleShopLogo } from '@services/MarppleShop/renderApp/components/atoms/Icon';
import { CategoryLevel1_CODE } from '../../../../../shared/mps-shared/domain/category/types.ts';

const logoSvgs = {
  [CategoryLevel1_CODE.GOODS]: MarppleShopGoodsLogo,
  [CategoryLevel1_CODE.HANDMADE]: MarppleShopHandmadeLogo,
  [CategoryLevel1_CODE.BRAND_DEAL]: MarppleShopBrandDealLogo,
  [CategoryLevel1_CODE.EBOOK]: MarppleShopEbookLogo,
};

export const makeCateRootHeaderLeftLogo = (cateRootCode: CategoryLevel1_CODE): Html => {
  return html`<a
    href="${createBuilderByCateRootCode(cateRootCode).build()}"
    style="color: inherit;display: flex; gap: 4px;"
    ><div style="height: 21px;">${MarppleShopLogo}</div>
    <div style="height: 21px;">${logoSvgs[cateRootCode]()}</div></a
  >`;
};
